export default __webpack_public_path__ + "static/media/abbeville3.eee64974.jpg";